import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { authService, CognitoUser, SignInRequest } from '@aslanpay/portal-common-lib';

const useSignIn = ({
  onSuccess,
  onError,
}: UseMutationOptions<CognitoUser, Error, SignInRequest>) => {
  return useMutation<CognitoUser, Error, SignInRequest>(
    ({ email, password }: SignInRequest) =>
      authService.signIn({ email: email.toLowerCase(), password }),
    { onSuccess, onError }
  );
};

export default useSignIn;
